import React, { useState, useEffect } from "react";
import "../multiplierMaster/MultiplierMaster.scss";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import FetchData, { CreateEntry, UpdateEntry, GetOne } from "../../providers/dataProvider";
import { isRequired, CheckNull } from '../../utils/Validate';
import { ValidateMessages } from '../../constants/ValidateConstants';
import ErrorMessage from "../../components/common/ErrorMessage";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import { useNavigate } from "react-router-dom";

const defaultValues = {
  roleId: "",
  createdBy: localStorage.getItem("authidentity"),
  mlpPermissions: []
}

const AddNewMultiplierMaster = () => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(defaultValues)
  const [role, setRole] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [formSubmit, setFormSubmit] = useState(false)
  const [createMsg, setCreateMsg] = useState(null)
  const [show, setShow] = useState(false);
  const [multiplierList, setMultiplierList] = useState({});
  const [productGroup, setProductGroup] = useState(null);
  const [productFamily, setProductFamily] = useState(null);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: ""
  });

  const { data: userRole } = FetchData("userrole");
  const { data: subproductfamily, loading: subproductfamilyLoading, error: subproductfamilyError } = FetchData("productgroups", { familyId: 0 });
  const { data: productfamily, loading: productfamilyLoading, error: productfamilyError } = FetchData("productfamily");

  useEffect(() => {
    if (subproductfamily) {
      setProductFamily(subproductfamily)
    }
  }, [subproductfamily])

  const HandleRoleChange = (selected) => {
    setFormValues({ ...formValues, roleId: selected?.value })
    if (selected?.value) GetOne("rolemultiplier", { id: selected?.value }, setMultiplierList)
  }

  const HandleProductGroupChange = (selected) => {
    setProductGroup(selected)
  }

  useEffect(() => {
    if (productGroup?.value)
      setProductFamily(subproductfamily?.filter(item => item?.productFamilyId === productGroup?.value))
    else
      setProductFamily(subproductfamily)
  }, [productGroup])

  useEffect(() => {
    if (multiplierList?.data?.roleId) setFormValues(multiplierList?.data)
    else setFormValues({ ...defaultValues, roleId: formValues?.roleId })
  }, [multiplierList])

  const HandleChange = (e, item, field) => {
    const { name, value, type } = e.target;

    const finalValue =
      type === "number" ? (value === "" ? "" : Number(value)) : value;

    setFormValues((prevFormValues) => {
      const mlpPermissionsCopy = [...prevFormValues?.mlpPermissions];

      const index = mlpPermissionsCopy.findIndex(
        (i) => i.productGroupId === item.id
      );

      if (index === -1) {
        return {
          ...prevFormValues,
          mlpPermissions: [
            ...mlpPermissionsCopy,
            {
              id: 0,
              roleMultiplierId: 0,
              productGroupId: item?.id,
              productFamilyId: item?.productFamilyId,
              [name]: finalValue,
              [field]: ""
            },
          ],
        };
      } else {
        mlpPermissionsCopy[index] = {
          ...mlpPermissionsCopy[index],
          [name]: finalValue,
        };

        return {
          ...prevFormValues,
          mlpPermissions: mlpPermissionsCopy,
        };
      }
    });
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    setFormErrors(Validation(formValues))
    setFormSubmit(true);
  }

  const Validation = (values) => {
    let errors = {};
    if (!isRequired(values.roleId))
      errors.role = ValidateMessages?.REQUIRED("Role");

    // const validFormData = values?.mlpPermissions?.filter((item) => {
    //   const { salesMargin, maximumDiscount } = item;
    //   return (
    //     (salesMargin > 0 && maximumDiscount > 0)
    //   );
    // });

    // if (validFormData?.length <= 0)
    //   errors.requiremultiplier = ValidateMessages?.VALID("multiplier");
    const uniquePermissions = Object.values(
      values.mlpPermissions.reduce((acc, item) => {
        acc[item.productGroupId] = item; // overwrite duplicates
        return acc;
      }, {})
    );
    const invalidItems = uniquePermissions?.filter((item) => {
      const maximumDiscount = Number(item?.maximumDiscount);

      return maximumDiscount > 100;
    });

    errors.InvalidMultiplier = invalidItems?.length > 0 ? invalidItems : undefined;
    let error = {}
    Object.keys(errors).map((key, index) => {
      if (errors[key] !== undefined)
        error[key] = errors[key]
    })
    return error;
  }

  const handleMainFormChange = (e) => {
    const { name, value, type } = e.target;
    const finalValue = type === "number" ? Number(value) : value;

    setFormValues((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    if (name === "approvalRank" && finalValue > 0 && formErrors?.approvalRank) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated.approvalRank;
        return updated;
      });
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && formSubmit) {
      const validFormData = formValues?.mlpPermissions?.filter((item) => {
        const { salesMargin, maximumDiscount } = item;
        return (
          (salesMargin > 0 && maximumDiscount > 0)
        );
      });
      const formValuesCopy = { ...formValues, mlpPermissions: validFormData, approvalRank: formValues?.approvalRank }
      if (CheckNull(formValuesCopy?.id) !== "") {
        const formValuesData = { ...formValuesCopy, ModifiedBy: localStorage.getItem("authidentity") }
        UpdateEntry("rolemultiplier", formValuesData, setCreateMsg, SuccessMessages?.UPDATED("Multiplier"), ErrorMessages?.UPDATE_ERROR("Multiplier"))
      } else {
        CreateEntry("rolemultiplier", formValuesCopy, setCreateMsg, SuccessMessages?.CREATED("Multiplier"), ErrorMessages?.CREATE_ERROR("Multiplier"))
      }
      setFormErrors({});
    }
    setFormSubmit(false);
  }, [formErrors]);


  const getErrorMessage = (errorData) => {
    if (!errorData) return "";
    if (typeof errorData === "string") return errorData;

    const { errors, statusPhrase } = errorData;

    if (typeof errors === "string") return errors;

    if (Array.isArray(errors)) {
      return errors
        .map((err) =>
          typeof err === "string"
            ? err
            : err?.message || err?.description || err?.errorMessage || ""
        )
        .filter(Boolean)
        .join(", ");
    }

    return statusPhrase || "";
  }

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes("Failed")) {
      setFormErrors((prev) => ({
        ...prev,
        approvalRank: getErrorMessage(createMsg?.successData)
      }));
    }
    else if (CheckNull(createMsg?.message) !== "") {
      setShow(true)
      setFormValues({})
    }
  }, [createMsg])

  const SuccessDoneClick = () => {
    setShow(false);
    setCreateMsg(null);
  }

  const ErrorDoneClick = () => {
    setErrorShow(
      {
        show: false,
        errorMessage: ""
      })
    setCreateMsg(null);
  }

  const HandleCancel = () => {
    navigate("/multiplier-master")
  }

  return (
    <div className="container-fluid add-new-multiplier-sec">
      <section className="multiplier-add-sec">
        <div className="row m-0">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 my-auto">
                    <div className="text-center text-sm-left mb-2 mb-sm-0">
                      <h6>Multiplier Master</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        Role <span className="mandatory">*</span>
                      </label>
                      <DropDownComponent
                        isDisabled={false}
                        pageName="multipliermaster"
                        placeHolder={PlaceHolder?.SELECT_ROLE}
                        dpDownName="role"
                        stateData={userRole}
                        controlName="role"
                        handleChange={HandleRoleChange}
                        value={role}
                        valueId={formValues?.roleId}
                        setState={setRole} />
                    </div>
                  </div>
                  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-3">
                    {formValues?.roleId && (
                      <div>
                        <label>Approval Rank</label>
                        <input
                          type="number"
                          name="approvalRank"
                          className="form-control"
                          value={formValues?.approvalRank || ""}
                          onChange={handleMainFormChange}
                        />
                        {formErrors?.approvalRank && (
                          <p className="form-error">{formErrors.approvalRank}</p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    {formValues?.roleId && (<>
                      <div>
                        <div className="save-btns text-center text-sm-right mb-2 mb-sm-0">
                          {/* <button className="btn cancel-btn" onClick={HandleCancel}>Cancel</button> */}
                          <button className="btn save-btn" onClick={HandleSubmit}>Save</button>
                        </div>
                      </div></>)}
                  </div>
                </div>
                {formValues?.roleId && (<>
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="header d-flex justify-content-between align-items-center">
                        <h1>Product</h1>
                        <DropDownComponent
                          isDisabled={false}
                          pageName="multipliermaster"
                          placeHolder={PlaceHolder?.SELECT_FAMILY}
                          dpDownName="productFamily"
                          stateData={productfamily}
                          controlName="productFamily"
                          handleChange={HandleProductGroupChange}
                          value={productGroup}
                          valueId={productGroup?.value}
                          setState={setProductGroup}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row product-group-table-row mt-1">
                    {formErrors?.requiremultiplier && <p className="form-error">{formErrors?.requiremultiplier}</p>}
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                      <div className="table-responsive multiplier-cards-table">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Product Group</th>
                              <th>Product Family</th>
                              <th className="text-center">Sales Margin (%)</th>
                              <th className="text-center">Maximum Discount (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {productFamily?.map((group, index) => {
                              const familyName = productfamily?.find(item => item?.id === group?.productFamilyId)?.family
                              const findValue = formValues?.mlpPermissions?.find(item => item?.productGroupId === group?.id)
                              const invalidItem = formErrors?.InvalidMultiplier?.find(item => item?.productGroupId === group?.id)
                              return (
                                <tr key={group?.id ?? index}>
                                  <td className="multiplier-group-cell" data-label="Product Group">{group?.group}</td>
                                  <td data-label="Product Family">{familyName}</td>
                                  <td data-label="Sales Margin (%)">{findValue?.salesMargin}</td>
                                  <td className="text-center multiplier-discount-cell" data-label="Maximum Discount (%)">
                                    <input
                                      type="number"
                                      className="form-control"
                                      style={{ textAlign: "right" }}
                                      value={findValue?.maximumDiscount || ""}
                                      name="maximumDiscount"
                                      onChange={(e) => HandleChange(e, group, "maximumDiscount")}
                                      onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    />
                                    {invalidItem && invalidItem?.maximumDiscount > 100 && (
                                      <p className="form-error">{ValidateMessages?.VALID("maximum discount")}</p>
                                    )}
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div></>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      {/* <!-- saveSuccessModal--> */}
      <SaveSuccessModel
        show={show}
        createMsg={createMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />
    </div>
  );
};

export default AddNewMultiplierMaster;
